/**
 * Showcase — "See it in action" screenshots on the explainer pages (Stage 3 polish, 1 Oct 2026).
 *
 * HOW TO ADD A PICTURE: save it as  admin-panel/public/marketing/<file>  (exact file name below each frame).
 *   phone screenshots: portrait, e.g. 1080 × 2340 · portal screenshots: landscape, e.g. 1600 × 1000. PNG or JPG
 *   (keep the .png name, or change `file` here). No code change needed.
 * While a picture is missing: on your computer (npm start) an empty frame shows its file name;
 * on the real website (npm run build) the empty frame is hidden.
 */
import React, { useState } from 'react';

const DEV = process.env.NODE_ENV !== 'production';

const Shot = ({ file, caption, kind }) => {
  const [missing, setMissing] = useState(false);
  if (missing && !DEV) return null;
  const phone = kind === 'phone';
  const frame = phone
    ? { width: 220, aspectRatio: '9 / 19.5', borderRadius: 28, border: '6px solid #1d2d44' }
    : { width: 440, maxWidth: '100%', aspectRatio: '16 / 10', borderRadius: 12, border: '1px solid #233554' };
  return (
    <figure style={{ margin: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, maxWidth: '100%' }}>
      <div style={{ ...frame, overflow: 'hidden', background: '#0d1b2e', boxShadow: '0 12px 30px rgba(0,0,0,0.35)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {missing ? (
          <div style={{ color: '#5a6a85', fontSize: 12, textAlign: 'center', padding: 12, lineHeight: 1.5 }}>
            📷 Screenshot here<br />public/marketing/<br /><b style={{ color: '#8892B0' }}>{file}</b>
          </div>
        ) : (
          <img src={`/marketing/${file}`} alt={caption} onError={() => setMissing(true)} loading="lazy"
               style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top', display: 'block' }} />
        )}
      </div>
      <figcaption style={{ color: '#a8b2d1', fontSize: 14, textAlign: 'center', maxWidth: phone ? 220 : 440 }}>{caption}</figcaption>
    </figure>
  );
};

const Showcase = ({ title = 'See it in action', intro, items }) => (
  <section style={{ padding: '56px 16px', textAlign: 'center' }}>
    <h2 style={{ color: '#E6F1FF', fontSize: 32, margin: '0 0 12px' }}>{title}</h2>
    {intro && <p style={{ color: '#8892B0', maxWidth: 640, margin: '0 auto 32px', fontSize: 17, lineHeight: 1.6 }}>{intro}</p>}
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'flex-start', gap: 28, maxWidth: 1100, margin: '0 auto' }}>
      {items.map((it) => <Shot key={it.file} {...it} />)}
    </div>
  </section>
);

export default Showcase;
